module.exports = __webpack_public_path__ + "static/media/quality.7c80fa1f.png";